import taskgraphLogsRouterPaths from './taskgraphLogsRouterPaths';

export default taskgraphLogsRouterPaths;
